<section>
    <div class="wrapper">
        <article class="mrt-75">
            <div class="content">
                <div class="main-action-col">
                    <div class="masking-header">
                        <div class="row">
                            <div class="col-sm-5">
                                <div class="title-head">
                                    <div class="d-flex" style="justify-content: space-between;align-items: center;">
                                        <div class="header">
                                            <mat-icon aria-label="Home Page" style="cursor: pointer;"
                                                routerLink="/dashboard">home</mat-icon>
                                            <span class="backdrop-slash">/</span>
                                            <a routerLink="/camera-server/site-list">Site List</a>
                                            <span class="backdrop-slash">/</span>
                                            <span>Masking Data</span>
                                            <span class="backdrop-slash">/</span>
                                            <a routerLink="/camera-server/sitelist/{{potentialId}}">{{potentialId}}</a>
                                            <span class="backdrop-slash" *ngIf="siteData?.siteName">/</span>
                                            <span>{{siteData?.siteName}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-7">
                                <div class="filter-section">
                                    <div class="selection-area" *ngIf="siteData != null">
                                        <mat-form-field appearance="outline" class="form-feild">
                                            <mat-label class="asterix--before">Select Resolution </mat-label>
                                            <mat-select name="selResolution" [(ngModel)]="selResolution"
                                                [(value)]="selResolution" (ngModelChange)="onOptionsSelected($event)"
                                                [ngModelOptions]="{standalone: true}">
                                                <mat-option *ngFor="let v of resolutions"
                                                    value="{{v.id}}">{{v.name}}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <button mat-raised-button class="manual-sync" (click)="manualSync()">
                                        <mat-icon aria-label="Manual Sync" matTooltip="Manual Sync">sync</mat-icon>
                                    </button>
                                    <!-- <button mat-raised-button class="filter" (click)="handleOpenFilter()">
                                        <mat-icon aria-label="filter with another option"
                                            matTooltip="Filter">search</mat-icon>
                                    </button> -->
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="filter-section-feild" *ngIf="isFilterWithAnotherOption">
                    <mat-form-field appearance="outline" class="form-feild">
                        <mat-label>Potential Id </mat-label>
                        <input matInput placeholder="Potential ID" name="potentialId" [(ngModel)]="potentialId"
                            [ngModelOptions]="{standalone: true}" />
                    </mat-form-field>
                    <span>/</span>
                    <mat-form-field appearance="outline" class="form-feild">
                        <mat-label>Site Name </mat-label>
                        <input matInput placeholder="Enter Site Name" name="siteName" [(ngModel)]="siteName"
                            [ngModelOptions]="{standalone: true}" />
                    </mat-form-field>
                    <span>/</span>
                    <mat-form-field appearance="outline" class="form-feild">
                        <mat-label>VPN IP </mat-label>
                        <input matInput placeholder="Enter VPN IP" name="vpnIp" [(ngModel)]="vpnIp"
                            [ngModelOptions]="{standalone: true}" />
                    </mat-form-field>
                    <button mat-raised-button class="filter-btn" (click)="searchWith()">Search</button>
                </div>
                <!-- <div style="margin:25px;">
                    <table class="table table-striped" *ngIf="site != null && site.potentialId != null">
                        <thead>
                            <tr>
                                <th scope="col">Potential Id</th>
                                <th scope="col">Site Name</th>
                                <th scope="col">Analytic Id</th>
                                <th scope="col">VPN IP</th>
                                <th scope="col">Ret Days</th>
                                <th scope="col">Cam Details</th>
                                <th scope="col">AWS Server</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{site.potentialId}}</td>
                                <td>{{site.siteName}}</td>
                                <td><b>{{site.analyticId}}</b></td>
                                <td>{{site.vpnIp}}</td>
                                <td>
                                    <div style="color:dodgerblue;font-weight: bold;">{{site.retentionDays}}</div>
                                </td>
                                <td>{{site.camInfo}}</td>
                                <td>{{site.awsUrl}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div> -->

                <div class="masking-view">
                    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort matSortActive="created"
                        matSortDisableClear matSortDirection="desc">

                        <!-- Id Column -->
                        <ng-container matColumnDef="id">
                            <th mat-header-cell *matHeaderCellDef>Cam Unique ID </th>
                            <td mat-cell *matCellDef="let element"> {{element.camUniqueId}} </td>
                        </ng-container>

                        <!-- Site name Column -->
                        <ng-container matColumnDef="rtspUrl">
                            <th mat-header-cell *matHeaderCellDef>RTSP URL</th>
                            <td mat-cell *matCellDef="let element"> {{element.rtspUrl}} </td>
                        </ng-container>

                        <!-- Id Column -->
                        <ng-container matColumnDef="camDisplayName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Cam Name </th>
                            <td mat-cell *matCellDef="let element; let i= index;">{{element.camDisplayName}}</td>
                        </ng-container>

                        <!-- Camera list Column -->
                        <ng-container matColumnDef="timezone">
                            <th mat-header-cell *matHeaderCellDef> Timezone </th>
                            <td mat-cell *matCellDef="let element"> {{element.timezone}} </td>
                        </ng-container>

                        <!-- Out put List Column -->
                        <!-- <ng-container matColumnDef="vpnRtspPort">
                            <th mat-header-cell *matHeaderCellDef> VPN Port </th>
                            <td mat-cell *matCellDef="let element"> {{element.vpnRtspPort}} </td>
                        </ng-container> -->

                        <!-- View Column -->
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef> Mask </th>
                            <td mat-cell *matCellDef="let element">
                                <!-- <button class="updateBtn" matTooltip="Pull Masking Coordinates From Axis Camera" (click)="updateMaskData(element)" [ngClass]="{'disabled': !isAnalyticIdSeven}">
                                    Sync / Update 
                                </button> -->
                             <button class="maskBtn">
                                <a class="masking-btn" (click)="maskData(element)">
                                    Masking
                                </a>
                             </button>
                                <div class="resolutions">
                                    <span>{{selResolutionName}}</span>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selectedRow($event,row)">
                        </tr>
                    </table>
                    <div class="no_record_found_msg" *ngIf="dataSource.data.length === 0">
                        No Records Found!
                    </div>
                    <mat-paginator #paginator class="hide-ripple" [pageSizeOptions]="[10, 25, 100]"
                        [pageSize]="pageSize" [length]="totalRecords" (page)="changePaging($event)"
                        aria-label="Select page of users">
                    </mat-paginator>
                    <ng-template #lprModal let-modal>
                        <div class="modal-header">
                            <h4 class="modal-title" id="modal-basic-title">LPR Update</h4>
                        </div>

                        <div class="modal-body" *ngIf="selectedCam != null">
                            <div style="font-weight:bold;margin-top:5px"> Camera Name : {{selectedCam.camDisplayName}}
                            </div>
                            <input id="lprTrue" type="radio" name="lpr" [checked]="selectedCam.lprEnabled == true"
                                value="true" [(ngModel)]="selectedCam.lprEnabled">
                            <label for="lprTrue">&nbsp; &nbsp; ENABLE LPR</label><br>
                            <input id="lprFalse" type="radio" name="lpr" [checked]="selectedCam.lprEnabled == false"
                                value="false" [(ngModel)]="selectedCam.lprEnabled">
                            <label for="lprFalse">&nbsp; &nbsp; DISABLE LPR</label><br>
                            <i style="color: red;">
                                <b>NOTE : </b>Please restart docker after changing the status
                            </i>
                        </div>

                        <div class="modal-footer">
                            <button type="button" class="btn btn-outline-dark"
                                (click)="modal.close('update')">Update</button>
                            <button type="button" class="btn btn-outline-dark"
                                (click)="modal.close('cancel')">Cancel</button>
                        </div>
                    </ng-template>


                    <ng-template #mymodal let-modal>
                        <div class="modal-header">
                            <h4 class="modal-title" id="modal-basic-title">Update Details</h4>
                        </div>
                        <div class="modal-body" *ngIf="selectedCam != null">
                            <div style="font-weight:bold;margin-top:5px">Enter Private IP</div>
                            <input type="text" [(ngModel)]="selectedCam.privateIp" />
                            <br />
                            <div style="font-weight:bold;margin-top:5px">Enter Local RTSP Port (554)</div>
                            <input type="text" [(ngModel)]="selectedCam.rtspPort" />
                            <br />
                            <div style="font-weight:bold;margin-top:5px">Enter VPN Rtsp Port</div>
                            <input type="text" [(ngModel)]="selectedCam.vpnRtspPort" />
                            <br />
                            <div style="font-weight:bold;margin-top:5px">Enter Macaddress (optional)</div>
                            <input type="text" [(ngModel)]="selectedCam.macaddress" />
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-outline-dark"
                                (click)="modal.close('update')">Update</button>
                            <button type="button" class="btn btn-outline-dark"
                                (click)="modal.close('cancel')">Cancel</button>
                        </div>
                    </ng-template>
                </div>
            </div>
        </article>
    </div>
</section>